import {
	ADD_PRODUCT_BY_REF,
	ADD_PRODUCTS_BY_REF,
	GET_PROJECT,
	CREATE_PROJECT,
	EMPTY_PROJECT_DETAILS,
	CLONE_PRODUCT,
	VERSION_PROJECT,
	GET_PROJECT_VERSIONS,
	DELETE_PRODUCT,
	UPDATE_PROJECT,
	GET_PROJECT_TOOLTIP_INFO,
	UPDATE_PRODUCT,
	UPDATE_PROJECT_THIRD_PARTY
} from '@/redux/actions/project.actions'
import { LOGOUT } from '@/redux/actions/auth.actions'

const initialState = {
	loading: false,
	error: false,
	details: {},
	versions: [],
	creating: false,
	addingProduct: false,
	cloningProduct: false,
	versioningProduct: false,
	deletingProduct: false,
	updatingProduct: false,
	loadingTitleEditing: false,
	tooltipInfo: {
		loading: false,
		details: {}
	},
	requestBudget: {
		existing: null
	}
}

const loading = (state = initialState.loading, action) => {
	switch (action.type) {
		case GET_PROJECT.REQUEST:
		case UPDATE_PROJECT.REQUEST:
			return !action.payload?.hotUpdate
		case GET_PROJECT.SUCCESS:
		case GET_PROJECT.FAILURE:
			return false
		default:
			return state
	}
}

const creating = (state = initialState.creating, action) => {
	switch (action.type) {
		case CREATE_PROJECT.REQUEST:
			return true
		case CREATE_PROJECT.SUCCESS:
		case CREATE_PROJECT.FAILURE:
			return false
		default:
			return state
	}
}

const error = (state = initialState.error, action) => {
	switch (action.type) {
		case GET_PROJECT.FAILURE:
			return true
		case GET_PROJECT.REQUEST:
		case GET_PROJECT.SUCCESS:
		case CLONE_PRODUCT.REQUEST:
		case CLONE_PRODUCT.SUCCESS:
		case VERSION_PROJECT.REQUEST:
		case VERSION_PROJECT.SUCCESS:
		case DELETE_PRODUCT.REQUEST:
		case DELETE_PRODUCT.SUCCESS:
		case UPDATE_PROJECT.REQUEST:
		case UPDATE_PROJECT.SUCCESS:
			return false
		default:
			return state
	}
}

const details = (state = initialState.details, action) => {
	switch (action.type) {
		case UPDATE_PROJECT.SUCCESS:
			return {
				...state,
				...Object.entries(action.payload).reduce(
					(acc, [key, value]) => ({
						...acc,
						[key]: value
					}),
					{}
				)
			}

		case GET_PROJECT.SUCCESS:
			return {
				...action.payload,
				products: action.payload.products?.reduce(
					(acc, product) => {
						return {
							orderedIds: [...acc.orderedIds, product._id],
							byId: { ...acc.byId, [product._id]: product },
							byType: {
								...acc.byType,
								[product.type]: acc.byType[product.type] ? [...acc.byType[product.type], product._id] : [product._id]
							}
						}
					},
					{ orderedIds: [], byId: {}, byType: {} }
				)
			}

		case UPDATE_PROJECT_THIRD_PARTY:
			return { ...state, isAssignedThirdparty: action.payload || 0 }

		case EMPTY_PROJECT_DETAILS:
		case LOGOUT.SUCCESS:
		case LOGOUT.FAILURE:
			return {}
		case DELETE_PRODUCT.SUCCESS:
			return {
				...state,
				products: {
					orderedIds: state.products.orderedIds.filter((productId) => productId !== action.payload.productId),
					byId: Object.values(state.products.byId).reduce((acc, product) => {
						if (product._id === action.payload.productId) {
							return acc
						}

						return {
							...acc,
							[product._id]: product
						}
					}, {}),
					byType: Object.values(state.products.byId).reduce((acc, product) => {
						if (product._id === action.payload.productId) {
							return acc
						}

						return {
							...acc,
							[product.type]: product
						}
					}, {})
				}
			}
		default:
			return state
	}
}

const addingProduct = (state = initialState.addingProduct, action) => {
	switch (action.type) {
		case ADD_PRODUCT_BY_REF.REQUEST:
		case ADD_PRODUCTS_BY_REF.REQUEST:
			return true
		case ADD_PRODUCT_BY_REF.SUCCESS:
		case ADD_PRODUCTS_BY_REF.SUCCESS:
		case ADD_PRODUCT_BY_REF.FAILURE:
		case ADD_PRODUCTS_BY_REF.FAILURE:
			return false
		default:
			return state
	}
}

const cloningProduct = (state = initialState.cloningProduct, action) => {
	switch (action.type) {
		case CLONE_PRODUCT.REQUEST:
			return action.payload
		case CLONE_PRODUCT.SUCCESS:
		case CLONE_PRODUCT.FAILURE:
			return null
		default:
			return state
	}
}

const versioningProduct = (state = initialState.versioningProduct, action) => {
	switch (action.type) {
		case VERSION_PROJECT.REQUEST:
			return action.payload
		case VERSION_PROJECT.SUCCESS:
		case VERSION_PROJECT.FAILURE:
			return null
		default:
			return state
	}
}

const getProjectVersions = (state = initialState.versions, action) => {
	switch (action.type) {
		case GET_PROJECT_VERSIONS.SUCCESS:
			return action.payload
		case GET_PROJECT_VERSIONS.FAILURE:
			return initialState.versions
		case GET_PROJECT_VERSIONS.REQUEST:
		default:
			return state
	}
}

const deletingProduct = (state = initialState.deletingProduct, action) => {
	switch (action.type) {
		case DELETE_PRODUCT.REQUEST:
			return action.payload
		case DELETE_PRODUCT.SUCCESS:
		case DELETE_PRODUCT.FAILURE:
			return null
		default:
			return state
	}
}

const tooltipInfo = (state = initialState.tooltipInfo, action) => {
	switch (action.type) {
		case GET_PROJECT_TOOLTIP_INFO.REQUEST:
			return { ...state, loading: true }
		case GET_PROJECT_TOOLTIP_INFO.SUCCESS:
			return {
				details: action.payload,
				loading: false
			}
		case GET_PROJECT_TOOLTIP_INFO.FAILURE:
			return { ...state, loading: false }
		default:
			return state
	}
}

const updatingProduct = (state = initialState.updatingProduct, action) => {
	switch (action.type) {
		case UPDATE_PRODUCT.REQUEST:
			return true
		case UPDATE_PRODUCT.SUCCESS:
		case UPDATE_PRODUCT.FAILURE:
			return false
		default:
			return state
	}
}

export default {
	name: 'project',
	reducers: {
		loading,
		error,
		creating,
		details,
		addingProduct,
		cloningProduct,
		versioningProduct,
		deletingProduct,
		tooltipInfo,
		updatingProduct,
		versions: getProjectVersions
	}
}
